import { useState, forwardRef } from "react";
import { ToastContainer } from "react-toastify";
import up from "../../images/LandingPageImage/up.svg";

import down from "../../images/LandingPageImage/down.svg";

// Using forwardRef to allow passing a ref to the FAQSection
const FAQSection = forwardRef((props, ref) => {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <ToastContainer />
      <div ref={ref} className="d-flex bg-white  justify-content-center padding-5-rem  p-lg-0">
        <div className="  border-15-only width-50  p-3 " style={{ border: "1px solid #ccc" }}>
          <div className="text-center text-2-2 py-4 text-green-text">FAQs</div>

          <div   className={`faq-item border-bottom-5-css p-4 my-1 border-15-only ${openIndex === 0 ? 'faq-gray-bg' : ''}`}>
            <div className="faq-question text-3-2-dark-dark d-flex justify-content-between align-items-center">
              <div className="ps-0">What is meant by the expression "WhatsApp Automation"?
              </div>
              <div
                type="button"
                className="p-2"
                onClick={() => handleToggle(0)}
              >
                {openIndex === 0 ? <img src={up} alt="dropdown" height={10} />: <img src={down} alt="dropdown" height={10} />}
              </div>
            </div>
            <div className={`faq-answer ${openIndex === 0 ? "open" : ""}`}>
             <hr />
              <div className="pt-2">
              Configuring processes to ensure specific tasks are carried out automatically without your continuous involvement is referred to as WhatsApp automation. Automation is useful, for example, when you regularly send identical messages or need to reply to clients quickly. Time is conserved, tasks are finished faster, and your clients are pleased as they get quick replies.

              </div>
            </div>
          </div>

          <div className={`faq-item border-bottom-5-css p-4 my-1 border-15-only ${openIndex === 1 ? 'faq-gray-bg' : ''}`}>
            <div className="faq-question text-3-2-dark-dark d-flex justify-content-between align-items-center">
              <div className="ps-0">What is WhatsApp Bulk messages ?</div>
              <div
                className="p-2"
                onClick={() => handleToggle(1)}
              >
                {openIndex === 1 ?<img src={up} alt="dropdown" height={10} />: <img src={down} alt="dropdown" height={10} />}
              </div>
            </div>
            <div className={`faq-answer ${openIndex === 1 ? "open" : ""}`}>
            <hr />
              <div className="pt-2">
              You can send a lot of messages to many  people at once with WhatsApp Bulk Messaging. By connecting  with the WhatsApp API, our site Anlook makes the process easy and lets you compose messages, choose recipients, and schedule or send them fastly . It's a  method of swiftly and successfully reaching a large audience.
              </div>
            </div>
          </div>

          <div className={`faq-item border-bottom-5-css p-4 my-1 border-15-only ${openIndex === 2 ? 'faq-gray-bg' : ''}`}>
            <div className="faq-question text-3-2-dark-dark d-flex justify-content-between align-items-center">
              <div className="ps-0">Does bulk messaging on WhatsApp follow the company's terms of service and is it legal?
              </div>
              <div
                className="p-2"
                onClick={() => handleToggle(2)}
              >
                {openIndex === 2 ? <img src={up} alt="dropdown" height={10} />: <img src={down} alt="dropdown" height={10} />}
              </div>
            </div>
            <div className={`faq-answer ${openIndex === 2 ? "open" : ""}`}>
            <hr />
              <div className="pt-2">
              Indeed, our platform guarantees adherence to both the legal requirements concerning bulk messaging and WhatsApp's terms of service. Only opted-in recipients who have agreed to receive communications from your company will receive messages because we closely follow WhatsApp's guidelines. Furthermore, we offer tools like Message Scheduling and Message Templates to boost user satisfaction and compliance.

              </div>
            </div>
          </div>

          <div className={`faq-item  p-4 my-1 border-15-only ${openIndex === 3 ? 'faq-gray-bg' : ''}`}>
            <div className="faq-question text-3-2-dark-dark d-flex justify-content-between align-items-center">
              <div className="ps-0">Can You Automate Messages on WhatsApp?
              </div>
              <div
                className="p-2"
                onClick={() => handleToggle(3)}
                style={{cursor:"pointer"}}
              >
                {openIndex === 3 ? <img src={up} alt="dropdown" height={10} />: <img src={down} alt="dropdown" height={10} />}
              </div>
            </div>
            <div className={`faq-answer ${openIndex === 3 ? "open" : ""}`}>
            <hr />
              <div className="pt-2">
              Yeah, totally. If you’ve got the WhatsApp Business app, you can make it send messages by itself — like a quick "Hey, thanks for reaching out!" when someone texts first, or a message saying you're not available if you're away. And if you’re using the WhatsApp API, you can go even further. It can send updates about orders, remind people to pay, or even answer the same questions over and over for you. So yeah, no need to sit and type every single reply — it kind of does the boring stuff for you.

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default FAQSection;
